<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 32,
      height: 32,
      color: 'currentColor',
      viewBoxValue: `0 0 33 32`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <g id="annotation-info">
      <path
        id="Icon"
        d="M16.8027 18.6667V14M16.8027 9.33333H16.8161M14.0027 25.6L15.9494 28.1956C16.2389 28.5815 16.3836 28.7745 16.5611 28.8436C16.7165 28.904 16.889 28.904 17.0444 28.8436C17.2218 28.7745 17.3666 28.5815 17.6561 28.1956L19.6027 25.6C19.9936 25.0788 20.189 24.8183 20.4274 24.6193C20.7452 24.3541 21.1205 24.1664 21.5234 24.0713C21.8256 24 22.1513 24 22.8027 24C24.6665 24 25.5984 24 26.3335 23.6955C27.3136 23.2895 28.0923 22.5108 28.4983 21.5307C28.8027 20.7956 28.8027 19.8638 28.8027 18V10.4C28.8027 8.15979 28.8027 7.03968 28.3668 6.18404C27.9833 5.43139 27.3713 4.81947 26.6187 4.43597C25.763 4 24.6429 4 22.4027 4H11.2027C8.96252 4 7.84242 4 6.98677 4.43597C6.23412 4.81947 5.6222 5.43139 5.23871 6.18404C4.80273 7.03968 4.80273 8.15979 4.80273 10.4V18C4.80273 19.8638 4.80273 20.7956 5.10722 21.5307C5.51319 22.5108 6.29189 23.2895 7.272 23.6955C8.00709 24 8.93897 24 10.8027 24C11.4542 24 11.7799 24 12.0821 24.0713C12.485 24.1664 12.8602 24.3541 13.1781 24.6193C13.4164 24.8183 13.6119 25.0788 14.0027 25.6Z"
        stroke="#667085"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </IconBase>
</template>

<style scoped lang="scss"></style>
